module.exports = __webpack_public_path__ + "img/129.86bdfca7.svg";